export default {"src":"/_next/static/media/light_theme.5f0bed6b.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};